// extracted by mini-css-extract-plugin
export default {"item":"DoctorSelector_item__OvoeG"};